import React from 'react'
import styled from 'styled-components'
import PropTypes  from 'prop-types';


const StyledContainer = styled.div`
  background: white;
  box-shadow: 0 1px 4px rgba(0,0,0,.15);
  padding: 2px;
  @media (max-width: 500px) {
    width:150%;
  }
`

const Title = styled.h4`
  padding: 10px 0px 10px;
  color: black;
  font-weight: 300;
  text-align: center;
  margin:auto;
  @media (max-width: 500px) {
    font-size: 1rem;
  }
`

const Header = styled.div`
  margin:0px
  display:flex;
  justify-content: space-around;
`

const HeaderItem = styled.div`
  color: white;
  width: 120px;
  max-width: 120px;
  margin: 10px;
  text-align: center;
  @media (max-width: 500px) {
    font-size: 0.8rem;
    margin: 5px;
  }
  `
const Row = styled.div`
  margin:0px
  display:flex;
  border-bottom: 1px dashed grey;
  justify-content: space-around;
`

const RowItem = styled.div`
  color: black;
  margin: 10px;
  text-align:center;
  word-wrap: break-word;
  overflow-x: auto;
  width: 120px;
  max-width: 120px;
  @media (max-width: 500px) {
    font-size: 0.8rem;
    margin: 0px;
    margin-left:5px;
  }
`

const Action = styled.button`
  display: block;
  margin: auto;
  width: 120px;
  :hover {
    opacity: 0.8;
  }
  @media (max-width: 500px) {
      width: 25%;
      margin-bottom: 4px;
      font-size: 0.65rem;
    }
  `
function redirectPage(link,id) {
  window.location.href = './#'+link+id
}

const MaterialList = ({
  title,
  header,
  columns,
  data,
  onClick,
  link
}) => {
  console.log('header....')
  console.log(header)
  return(

  <StyledContainer>
    <Title className='heading2'>{title}</Title>
    <Header className='label_blue_1' style={{backgroundColor:'#115691',color:'white',fontWeight:900}}>
      {header.map(value=>
        <HeaderItem>{value}</HeaderItem>
      )}
    </Header>
    { data ?
      data.map((items,key)=>
      <Row>
        {columns.map((column,index)=>
          <RowItem >
            { items[column] && typeof items[column] === 'object' && items[column].constructor === Array ?
                items[column].map((each)=>
                  column == 'games' ?
                      <img src={each.game_icon} alt={each.game_name} style={{width:'25%'}}/>
                    
                  :
                    <div>
                      <div>{each.name}</div>
                      <div>{each.number}</div>
                      <br></br>
                    </div>
                  )
            :
            column == 'revenue' ?
              <span>&#8377; {items[column]}</span>
              :
              column == 'name'?
                <span style={{color:'#115691',cursor:'pointer',fontWeight:'900'}} onClick={()=>{redirectPage(link,items['id'])}}>{items[column]}</span>
              :
              column == 'status' ?
                items[column] == 'Open' ?
                    <i style={{color:'green'}} className='fa fa-check-circle fa-lg'></i>
                : 
                    <i style={{color:'red'}} className='fa fa-times-circle fa-lg'></i>
              : 
              items[column]
            }
          </RowItem>
        )}
      </Row>
      )
    :
    <Row></Row>
    }
  </StyledContainer>
);
};

MaterialList.propTypes = {
  onClick:  PropTypes.func
};





export default MaterialList;



// WEBPACK FOOTER //
// ./src/app/components/materialList/MaterialList.js